<template>
  <div>
    <b-card>
      <!-- if data not empty -->
      <div v-if="payments.length !== 0">
        <b-table
          responsive="sm"
          :items="payments"
          :fields="fields"
        >
          <template #cell(batch)="data">
            {{ data.item.batch }}
          </template>

          <template #cell(intake)="data">
            {{ data.item.intake }}
          </template>

          <template #cell(amount)="data">
            {{ getPrice(data.value) }}
          </template>

          <template #cell(payment_date)="data">
            {{ momentTimestampFormat(data.value, "YYYY-MM-DD") }}
          </template>

          <!-- Adding View invoice link -->

          <template #cell(actions)="data">
            <b-link @click="viewInvoice(data.item)">
              View Invoice
            </b-link>
          </template>
        </b-table>
      </div>

      <!-- if data empty -->
      <div
        v-else
        class="text-center"
      >
        <span class="font-weight-bold">No Result</span>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BModal,
  BCard,
  BTable,
  BBadge,
  BButton,
  BCol,
  BRow,
  BCardText,
  BAvatar,
  BLink,
  BContainer,
} from 'bootstrap-vue'

export default {
  name: 'PaymentTable',
  components: {
    BCard,
    BModal,
    BButton,
    BCol,
    BBadge,
    BAvatar,
    BTable,
    BRow,
    BContainer,
    BCardText,
    BLink,
  },
  props: {
    payments: Array,
  },
  data() {
    return {
      show: false,
      selectedItem: {},

      fields: [
        {
          key: 'batch',
          label: 'Batch',
          sortable: true,
        },
        {
          key: 'intake',
          label: 'Intake',
          sortable: true,
        },
        {
          key: 'amount',
          label: 'Paid Amount',
          sortable: true,
        },

        {
          key: 'payment_date',
          label: 'Payment Date',
          sortable: true,
        },
        {
          key: 'actions',
          label: 'Invoice',
        },
      ],
    }
  },
  methods: {
    viewInvoice(item) {
      const invoiceData = {
        id: item.id,
        student: item.student || 'Unknown',
        date: item.payment_date,
        amount: item.amount,
        paid: item.amount, // current payment
        total: item.total || 30000, // adjust if you have this
        due: item.due || 0,
      }
      console.log('Invoice clicked:', item)

      window.open(`/invoice/${item.id}`, '_blank')

      // Example 2: Open in new tab
      // window.open(`/invoice/${item.id}`, "_blank");
    },

    getPrice(val) {
      return `Rs ${val}`
    },

    momentFormat(date, format) {
      return date
    },
  },
}
</script>

<style>
.custom-cell-padding {
  height: 70px; /* Set your desired padding value */
}
</style>
